module.exports = __webpack_public_path__ + "img/blog-1.5b395167.webp";